import * as Preact from "preact"
import "@frog/source/views/components/Camera.less"

export default class Camera {
    render() {
        return (
            <div class="Camera" style={this.style}>
                {this.props.children}
            </div>
        )
    }
    get style() {
        return {
            "left": -1 * this.props.chapter.selection.camera.position.x + "em",
            "top": -1 * this.props.chapter.selection.camera.position.y + "em",
            "font-size": (1 / (this.props.chapter.selection.camera.position.z ?? 1)) + "em",
        }
    }
}
